import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

export default function LanguageSelector() {
  const { language, setLanguage, languages, availableLanguages } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="flex items-center gap-2 text-mrc-navy hover:bg-gray-100"
          data-testid="language-selector"
        >
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{languages[language]?.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {availableLanguages.map((lang) => (
          <DropdownMenuItem 
            key={lang}
            onClick={() => setLanguage(lang)}
            className={`cursor-pointer flex items-center gap-2 ${language === lang ? 'bg-mrc-navy/10 font-semibold' : ''}`}
            data-testid={`lang-${lang}`}
          >
            <span className="text-lg">{languages[lang]?.flag}</span>
            <span>{languages[lang]?.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
